import styled from 'styled-components';
import { CopyrightCheckerStatus } from '../../../interfaces/CopyrightCheckerStatus';
export const Container = styled.div `
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;
export const Circle = styled.i `
    flex-shrink: 0;
    border-radius: 50%;
    display: inline-block;
    height: 0.5rem;
    width: 0.5rem;
    transform: translateY(1px);
    background-color: ${({ status }) => {
    switch (status) {
        case CopyrightCheckerStatus.CANCELLED:
            return `#b2babf`; // $gray-color
        case CopyrightCheckerStatus.WAITING:
            return `#2071AD`; // $info-color
        case CopyrightCheckerStatus.APPROVED:
            return `#FF8300`; // $primary-color
        case CopyrightCheckerStatus.PROCESSED:
            return `#6EBE44`; // $succes-color
        default:
            return `#E6EBEE`; // $alt-color
    }
}};
`;
